import WorkerIcon from 'assets/nav-icons/engineer-workers-icon.svg?react'
import LoginIcon from 'assets/nav-icons/login.svg?react'
import DocumentIcon from 'assets/nav-icons/document.svg?react'
import InfoIcon from 'assets/nav-icons/info.svg?react'
import CheckDoubleIcon from 'assets/nav-icons/check-double.svg?react'
import TruckIcon from 'assets/nav-icons/truck.svg?react'
import PeopleIcon from 'assets/nav-icons/people.svg?react'
import { NAV_TYPE_COLLAPSE, NAV_TYPE_ITEM } from 'constants/app.constant'

// ----------------------------------------------------------------------

const ROOT_WHS = '/whs';

const path = (root, item) => `${root}${item}`;

export const whs = {
    id: 'whs',
    type: NAV_TYPE_COLLAPSE,
    path: ROOT_WHS,
    title: 'WHS',
    transKey: 'WHS',
    Icon: WorkerIcon,
    permissionCode:"WHSWHSView",
    childs: [
        {
            id: 'whs.sign-in-out',
            type: NAV_TYPE_ITEM,
            path: path(ROOT_WHS, '/sign-in-out'),
            title: 'Check In & Check Out',
            transKey: 'Check In & Check Out',
            Icon: LoginIcon,
            permissionCode:"SISOSISOV",
        },
        {
            id: 'whs.incident-report',
            type: NAV_TYPE_ITEM,
            path: path(ROOT_WHS, '/incident-report'),
            title: 'Incident Report',
            transKey: 'Incident Report',
            Icon: DocumentIcon,
            permissionCode:"INRINRV",
        },
        {
            id: 'whs.toolbox-talks',
            type: NAV_TYPE_ITEM,
            path: path(ROOT_WHS, '/toolbox-talks'),
            title: 'Toolbox Talks',
            transKey: 'Toolbox Talks',
            Icon: InfoIcon,
            permissionCode:"TBTBV",
        }, {
            id: 'whs.vehicle-register',
            type: NAV_TYPE_ITEM,
            path: path(ROOT_WHS, '/vehicle-register'),
            title: 'Vehicle Register',
            transKey: 'Vehicle Register',
            Icon: TruckIcon,
            // Visible with either full "View Vehicle" or "View Assigned vehicles" —
            // the backend itself scopes the data returned to assigned-only for the latter.
            permissionCode: ["VHCVHCV", "VHCASSVEH"],
        },
        {
            id: 'whs.vehicle-start-checklist',
            type: NAV_TYPE_ITEM,
            path: path(ROOT_WHS, '/vehicle-start-checklist'),
            title: 'Vehicle Start Checklist',
            transKey: 'Vehicle Start Checklist',
            Icon: CheckDoubleIcon,
            permissionCode:"VHCVCV",
        },

        {
            id: 'whs.contractors-list',
            type: NAV_TYPE_ITEM,
            path: path(ROOT_WHS, '/contractors-list'),
            title: 'Contractors List',
            transKey: 'Contractors List',
            Icon: PeopleIcon,
            permissionCode:"CONCONV",
        },
    ]
}
